import { render, staticRenderFns } from "./BcCircleLoader.vue?vue&type=template&id=368cdb4f&scoped=true"
import script from "./BcCircleLoader.vue?vue&type=script&lang=js"
export * from "./BcCircleLoader.vue?vue&type=script&lang=js"
import style0 from "./BcCircleLoader.vue?vue&type=style&index=0&id=368cdb4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368cdb4f",
  null
  
)

export default component.exports